module.exports = __webpack_public_path__ + "static/fipcballmouse4-39d023015a62470c22952fc80df39cc8.jpeg";